import React, { Component } from "react";
import OutsideClickHandler from "react-outside-click-handler";

export class Tooltip extends Component {
    constructor() {
        super();
        this.state = {
            show: false,
        };
    }

    toggle() {
        this.setState({ show: !this.state.show });
    }

    render() {
        return (
            <OutsideClickHandler
                onOutsideClick={() => {
                    if (this.state.show) {
                        this.toggle();
                    }
                }}
            >
                <div onTouchStart={() => this.toggle()} className={`tooltip ${this.state.show && "show"}`}>
                    {this.props.children}
                </div>
            </OutsideClickHandler>
        );
    }
}
